/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/20
 * Copyright All Rights Reserved
 */
// @flow
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import ViewOrganizationsTable from './ViewOrganizationsTable';
import { ActionRow, ActionRowButton } from 'components/support/layout/ActionRow';

type Props = {
  match: {
    url: string,
  },
  poll: Function,
};

const ViewOrganizations = ({ match, poll }: Props) => {
  useEffect(poll);

  return (
    <div>
      <Row>
        <Col md="12">
          <h1>Organizations</h1>
        </Col>
      </Row>
      <ActionRow>
        <Col md="12" className="col">
          <ActionRowButton
            color="link"
            className="float-right create-organization-button"
            tag={Link}
            to={`${match.url}/create`}
          >
            Create Organization +
          </ActionRowButton>
        </Col>
      </ActionRow>
      <Row>
        <Col md="12">
          <ViewOrganizationsTable url={match.url} />
        </Col>
      </Row>
    </div>
  );
};

export default ViewOrganizations;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Organizations/ViewOrganizations/ViewOrganizations.jsx